export default {
  analyticsFilters(state) {
    return state.analyticsFilters
  },
  analyticsList(state) {
    return state.analyticsList
  },
  analyticsReport(state) {
    return state.analyticsReport
  },
  analyticsReportPeriod(state) {
    return state.analyticsReport.settings && state.analyticsReport.settings.period !== undefined
      ? state.analyticsReport.settings.period
      : null
  },
  analyticsReportSettings(state) {
    return state.analyticsReport.settings
  },
  analyticsData(state) {
    return state.analyticsData
  },
  analyticsDataItem(state) {
    const dataID =
      state.analyticsReport.settings && state.analyticsReport.settings.data_id !== undefined
        ? state.analyticsReport.settings.data_id
        : null

    let dataItem = null

    if (dataID) {
      _.each(state.analyticsData, item => {
        if (item.id === dataID) dataItem = item
      })
    }

    return dataItem
  },
  analyticsDataGraph(state) {
    return state.analyticsDataGraph
  },
  analyticsDataView(state) {
    return state.analyticsDataView
  },
  analyticsDataSum(state) {
    return state.analyticsDataSum
  },
  reportInfo(state) {
    return state.reportInfo
  },
  tableHeaders(state) {
    return state.tableHeaders
  },
  analyticsFormatName(state) {
    return state.analyticsFormatName
  },
  dataList(state) {
    return state.dataList
  },
  detailsList(state) {
    return state.detailsList
  },
  filtersList(state) {
    return state.filtersList
  },
  dates(state) {
    return state.dates
  },
  analyticsFillStudios(state) {
    return state.analyticsFillStudios
  },
}
